// device.service.ts

import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DeviceService {
    getUserAgent(): string {
        return window.navigator.userAgent;
    }
    // getUserAgentAPI(): Observable<string> {
    //   if (!this.userAgent) {
    //     return from(this.http.get('/api/user-agent')).pipe(
    //       map((response: any) => {
    //         this.userAgent = response.userAgent;
    //         return this.userAgent;
    //       })
    //     );
    //   } else {
    //     return of(this.userAgent);
    //   }
    // }
    isAndroid(userAgent: string): boolean {
        return /Android/i.test(userAgent);
    }

    isIPhone(userAgent: string): boolean {
        return /iPhone/i.test(userAgent);
    }

    isDesktop(userAgent: string): boolean {
        return !this.isAndroid(userAgent) && !this.isIPhone(userAgent);
    }

    isMobile(){
        const userAgent = window.navigator.userAgent;
        return /android|ipad|iphone/i.test(userAgent);
    }

    isInAppBrowser(userAgent: string){
        return /FBAN|FBAV|TikTok|Instagram|Youtube|Threads/i.test(userAgent);
    }

    private getBrowserName(ua: string): string {
        if (/edg/i.test(ua)) return 'Edge';
        if (/opr|opera/i.test(ua)) return 'Opera';
        if (/chrome|chromium|crios/i.test(ua)) return 'Chrome'; 
        if (/firefox|fxios/i.test(ua)) return 'Firefox';
        if (/safari/i.test(ua)) return 'Safari';
        return 'Desktop';
    }


    getDetails() {
        const userAgent = navigator.userAgent;
        const isIOS = /iPad|iPhone/.test(userAgent);
        const isAndroid = this.isAndroid(userAgent);

        const isInApp = this.isInAppBrowser(userAgent);

        let version = 0;
        const versionMatch = isIOS ? (navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/) || []).slice(1,3).filter(Boolean).join('.').replace('_', '.') : navigator.userAgent.match(/Android\s+([0-9]+)/)?.[1];
        version = Number(versionMatch || 0);
        return {
            isMobile: isIOS || isAndroid,
            isIOS,
            isAndroid,
            isInApp,
            version,
            browserName: this.getBrowserName(userAgent)
        };
    }
}
